import axios from './_nestAxios'

export const getTransaccion = _id => axios.get(`/transacciones/${_id}`)

export const actualizarTransaccion = (_id, data) => axios.put(`/transacciones/${_id}`, data)

export const getTransaccionCuentas12 = _id => axios.get(`/transacciones/${_id}/modeloCuentas12`)

export const getModeloCuentas12xId = (_id, idModeloCuentas12) => axios.get(`/transacciones/${_id}/modeloCuentas12/${idModeloCuentas12}`)

export const obtenerxCodigoAsSelectModelosCuenta12 = codigo =>
  axios.get('/transacciones', {
    params: {
      tipoConsulta: 'select-x-codigo',
      cod: codigo
    }
  })

export const obtenerxCodigoAsSelectPrincipalModeloCuenta12 = codigo =>
  axios.get('/transacciones', {
    params: {
      tipoConsulta: 'select-principal',
      cod: codigo
    }
  })

export const crearTransaccion = (data) => axios.post(`/transacciones`, data)

export const nuevoModeloCuentas12xIdTransaccion = (_id, data) => axios.post(`/transacciones/${_id}/modeloCuentas12`, data)

export const actualizarModeloCuentas12xIdTransaccionxId = (_id, idModeloCuentas12, data) =>
  axios.put(`/transacciones/${_id}/modeloCuentas12/${idModeloCuentas12}`, data)

export const eliminarTransaccionCuentas12 = (id, idModeloCuentas12) => axios.delete(`/transacciones/${id}/modeloCuentas12/${idModeloCuentas12}`)
